import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import Grid from '@quintoandar/cozy-core/Grid';
import Form from '@quintoandar/cozy-core/Form';
import Radio from '@quintoandar/cozy-core/Radio';
import RadioGroup from '@quintoandar/cozy-core/RadioGroup';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';

import { getMessageByIntlKey } from 'components/DynamicForm/getMessageByIntlKey';

import messages from './messages';

const transformChoice = ({ title, value: key, extra, checked = false }) => ({
  key,
  label: title,
  name: key,
  extra,
  checked,
});

export const transformChoiceValues = ({ choiceValues }) => choiceValues.map(transformChoice);

export const ChoiceRadio = ({
  value,
  choiceValues,
  groupName,
  onChange,
  onValidateItem,
  shouldValidate,
  children,
  intlKey,
  intl,
}) => {
  const items = transformChoiceValues({ choiceValues });
  const [valid, setValid] = useState(true);

  const hasValue = Boolean(value);

  useEffect(() => {
    if (onValidateItem) {
      onValidateItem(hasValue);
    }
  }, [hasValue]);

  useEffect(() => {
    if (shouldValidate && valid !== hasValue) {
      setValid(hasValue);
    }
  }, [shouldValidate, valid, hasValue]);

  return (
    <Box my={2}>
      <Box mb={2}>
        <Typography>
          {intl.formatMessage(getMessageByIntlKey({ availableMessages: messages, intlKey }))}
        </Typography>
      </Box>
      <Form>
        <RadioGroup name={groupName} initialValue={value} onChange={onChange}>
          {items.map((item, index) => {
            const message = getMessageByIntlKey({
              availableMessages: messages,
              intlKey: item.key,
            });
            const showChildren = value === item.key && children.length >= index;

            return (
              <Grid key={index} direction="column" container>
                <Grid item>
                  <Radio
                    name={groupName}
                    label={intl.formatMessage(message)}
                    value={item.key}
                  />
                </Grid>
                {showChildren ? (
                  children[index]
                ) : (
                  item.extra && (
                    <Grid item>
                      <Typography mb={2}>{item.extra.description}</Typography>
                    </Grid>
                  )
                )}
              </Grid>
            );
          })}
        </RadioGroup>
      </Form>
      {!valid &&
        <Typography kind="critical">
          <FormattedMessage {...messages.invalid} />
        </Typography>}
    </Box>
  );
};

ChoiceRadio.propTypes = {
  value: PropTypes.string,
  choiceValues: PropTypes.array,
  groupName: PropTypes.string,
  onChange: PropTypes.func,
  onValidateItem: PropTypes.func,
  shouldValidate: PropTypes.bool,
  children: PropTypes.array,
  intlKey: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(ChoiceRadio);
